const Service = () => {
  return (
    <section id="servicos" className="content-section">
      <div className="card mb-3">
        <div className="card-body text-center">
          <h5 className="card-title">Serviços</h5>
        </div>

        <div className="card-body">
          <div className="card">
            <ol className="list-styled">


              <div>
                <p className="mb-0">
                  <strong id="splash-page">Splash page</strong>
                </p>
                <p className="justified-text">
                  Permite vincular redes sem fio a um vídeo ou imagem da WEB. Ao conectar na rede sem fio, o dispositivo é redirecionado para o conteúdo e a visualização é obrigatória. Somente após finalizar o tempo de exibição é que o cliente terá total acesso à rede sem fio.<br />
                  <strong>Obs.: </strong>Esta funcionalidade só é acessível no modo de operação “Roteador”.
                </p>

                <div className="d-flex justify-content-center">
                  <img src="./res/figures/splash-page.png" className="card-img-bottom img-xl" alt="" />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Tipo de mídia: </strong>escolha entre um vídeo ou uma imagem
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Link da mídia: </strong>informe o link da imagem ou vídeo. Para vídeos, apenas links dos sites “Vimeo” ou “Youtube”.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Tempo mínimo de visualização (segundos): </strong>informe o tempo de visualização da mídia, em segundos. Tempo mínimo: 1 segundo. Tempo máximo: 120 segundos.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Tempo da sessão: </strong>informe o tempo máximo que o cliente pode ficar conectado na rede sem fio. Após o tempo finalizar, o cliente deve reconectar e visualizar a mídia configurada novamente. Mínimo: 1 minuto. Máximo: 60 dias.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Informações ao dispositivo conectado: </strong>Texto a ser exibido ao usuário após o encerramento do tempo mínimo de visualização da mídia. Caso este campo seja informado, o acesso total à rede sem fio só é concedido após a visualização da mídia e a confirmação da leitura deste texto.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Lista de SSIDs: </strong>Selecione as redes sem fio que exibirão a mídia configurada para visualização.
                    </p>
                  </li>
                </ul>
              </div>

              <div>
                <p className="mb-0">
                  <strong id="discovery">Discovery</strong>
                </p>
                <p className="justified-text">
                  Permite controlar a descoberta do produto na rede através de protocolos conhecidos.
                </p>

                <div className="d-flex justify-content-center">
                  <img src="./res/figures/servicos-discovery.png" className="card-img-bottom img-lg img-xl" alt="" />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Defesa contra ataque de Força Bruta: </strong>marque para ativar a proteção contra ataques de força bruta.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Protocolo LLDP: </strong>marque para permitir que o equipamento seja descoberto, através do protocolo LLDP.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Protocolo CDP: </strong>marque para permitir que o equipamento seja descoberto, através do protocolo CDP v1/v2.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Protocolo INTELBRAS: </strong>marque para permitir que o equipamento seja descoberto, através do protocolo Intelbras.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Permitir Discovery na interface WAN: </strong>marque para permitir que a função de Discovery passe a atuar na interface WAN.
                    </p>
                  </li>
                </ul>
              </div>



              <div>
                <p className="mb-0">
                  <strong id="ntp">NTP</strong>
                </p>
                <p className="justified-text">
                  Permite configurar os servidores que manterão o equipamento com data e hora atualizadas.
                </p>

                <div className="d-flex justify-content-center">
                  <img
                    src="./res/figures/ntp.png"
                    className="card-img-bottom img-lg img-xl"
                    alt=""
                  />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Habilitar cliente NTP: </strong>marque para manter o equipamento atualizado a
                          partir dos servidores NTP informados. Para as configurações de “Agendamento”, é necessário
                          que esta configuração esteja ativa.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Servidor NTP 1: </strong>configure um endereço de servidor NTP primário.
                          Servidores brasileiros são configurados por padrão.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Servidor NTP 2: </strong>configure um endereço de servidor NTP secundário.
                          Servidores brasileiros são configurados por padrão.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Zona: </strong>Selecione uma das quatro zonas horárias brasileiras: “GMT-2”,
                          “GMT-3”, “GMT-4” e “GMT-5".
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Horário de verão: </strong>Selecione caso a sua localização adota o horário de
                          verão.
                        </p>
                      </li>
                    </ul>
                  </ul>
                </ul>
              </div>



              <div>
                <p className="mb-0">
                  <strong id="snmp">SNMP</strong>
                </p>
                <p className="justified-text">
                  SNMP é um protocolo de comunicação usado em redes de computadores para monitorar e gerenciar dispositivos de rede.
                  O SNMP permite que administradores de rede obtenham informações sobre o status e o desempenho desses dispositivos,
                  além de configurá-los remotamente.
                </p>

                <div className="d-flex justify-content-center">
                  <img src="./res/figures/snmp.png" className="card-img-bottom img-xl" alt="" />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Habilitar SNMP: </strong>marque para habilitar a visualização das informações transmitidas via
                          protocolo SNMP.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Comunidade: </strong>informe o texto referente ao “SNMP Community”.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Porta SNMP: </strong>informe a porta UDP de comunicação com o agente SNMP. Por padrão, a porta é 161.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Localização: </strong>informe o texto referente à localização.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Contato: </strong>informe o texto referente ao contato.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Nome: </strong>informe o texto referente ao nome desejado para o aparelho.
                        </p>
                      </li>
                    </ul>
                  </ul>
                </ul>
              </div>

              <div>
                <p className="mb-0">
                  <strong id="watchdog">Watchdog</strong>
                </p>
                <p className="justified-text">
                  Função que reinicia o equipamento caso perca contato com um dispositivo da rede.
                </p>

                <div className="d-flex justify-content-center">
                  <img src="./res/figures/watchdog.png" className="card-img-bottom img-lg img-xl" alt="" />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Habilitar Watchdog: </strong>marque para habilitar a função “Watchdog”.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Endereço 1: </strong>endereço IP ou domínio principal de um dispositivo na rede que será monitorado
                          pelo equipamento. Caso perca contato e não houver endereço secundário configurado, o equipamento é reiniciado.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Endereço 2: </strong>endereço IP ou domínio secundário de um dispositivo na rede que será monitorado
                          pelo equipamento. Caso não exista comunicação com o dispositivo primário, e também não obtenha comunicação
                          com o secundário, o equipamento é reiniciado.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Tempo de checagem: </strong>informe o tempo de monitoramento dos endereços primário e secundário.
                        </p>
                      </li>
                    </ul>
                  </ul>
                </ul>
              </div>

              <div>
                <p className="mb-0">
                  <strong id="ddns">DDNS</strong>
                </p>
                <p className="justified-text">
                  DDNS é um serviço que permite associar um nome de domínio ao endereço IP endereço IPv4 público do equipamento. É
                  fornecido suporte a três serviços DDNS: Intelbras, No-IP e DynDNS. Obs.: Esta funcionalidade só é acessível no modo
                  de operação “Roteador”.
                </p>

                <div className="d-flex justify-content-center">
                  <img src="./res/figures/ddns.png" className="card-img-bottom img-lg img-xl" alt="" />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <p className="mb-0 justified-text">Para o serviço Intelbras DDNS:</p>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Domínio: </strong>informe a primeira parte do domínio. <strong>Obs.: </strong>A parte final do
                          domínio é fixa e inalterável: “.ddns-intelbras.com.br”.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>E-mail: </strong>informe o e-mail que receberá a confirmação da criação do domínio DDNS – Intelbras.
                          O e-mail é encaminhado alguns minutos após a configuração ser aplicada.
                        </p>
                      </li>
                      <p className="mb-0 justified-text">Para o serviço “No-IP” e “DynDNS”:</p>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Domínio: </strong>informe o domínio configurado no site do serviço escolhido.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Usuário: </strong>informe o configurado no site do serviço escolhido.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Senha: </strong>informe a senha de acesso configurada no site do serviço escolhido.
                        </p>
                        <p className="mb-0 justified-text">
                          <strong>Obs.: </strong>Para os serviços “No-IP” e “DynDNS”, a confirmação da configuração deve ser feita no
                          site do serviço escolhido.
                        </p>
                      </li>
                    </ul>
                  </ul>
                </ul>
              </div>

              <div>
                <p className="mb-0">
                  <strong id="agendamento">Agendamento</strong>
                </p>
                <p className="justified-text">
                  Em “Agendamento” é possível planejar a ativação/desativação das redes sem fio, dos LEDs e do reinício do equipamento.
                  Na parte superior da tela podem ser registrados os agendamentos. Na parte inferior da tela é possível vincular cada agendamento
                  ao funcionamento da rede sem fio (Wireless), dos LEDs e do reinício do equipamento. Um mesmo agendamento pode ser vinculado tanto para o funcionamento das redes sem
                  fio quanto para o funcionamento dos LEDs e também para o reinício do equipamento.  Para verificar o comportamento dos LEDs do produto, consultar a tabela
                  "Suporte à configuração dos LEDs" na seção "LED" abaixo.
                </p>

                <div className="d-flex justify-content-center">
                  <img src="./res/figures/agendamento.png" className="card-img-bottom img-xl" alt="" />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Tabela de agendamentos: </strong>informe a "descrição", os "dias da semana", "hora inicial" e "hora
                          final" do funcionamento do agendamento.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Wireless: </strong>Aba para vincular o agendamento criado na “Tabela de Agendamentos” a uma ou mais
                          redes sem fio.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>LED: </strong>Aba para vincular o agendamento criado na “Tabela de Agendamentos” ao LED do produto.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Reiniciar: </strong>Aba para vincular o agendamento criado na “Tabela de Agendamentos” ao reinício do produto.
                          O horário final do agendamento é ignorado; o equipamento reinicia apenas no horário de início.
                        </p>
                      </li>
                    </ul>
                  </ul>
                </ul>
              </div>

              <div>
                <p className="mb-0">
                  <strong id="led">LED</strong>
                </p>
                <p className="justified-text">
                  Configurações de funcionamento do LED do equipamento. Na configuração do LED é possível configurá-lo para
                  permanecer desligado em todos os modos de operação. Há duas formas de configuração:
                </p>

                <div className="d-flex justify-content-center">
                  <img src="./res/figures/led.png" className="card-img-bottom img-xl" alt="" />
                </div>

                <ul className="p-xss-0 p-md-3 justified-text pt-0">
                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Desligado: </strong>LEDs permanecerão apagados.
                        </p>
                      </li>
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Programar horários: </strong>configuração disponível caso existam agendamentos vinculados para o
                          LED.
                        </p>
                      </li>
                    </ul>
                  </ul>
                </ul>
              </div>

              <p className="mb-0 justified-text">
                <strong>
                  Suporte à configuração dos LEDs:
                </strong>
              </p>
              <div className="table-container">
                <table className="table">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col" className="text-center">
                        Modelo
                      </th>
                      <th scope="col" className="text-center">
                        Alteração de cores do LED
                      </th>
                      <th scope="col" className="text-center">
                        Apaga / acende LED
                      </th>
                      <th scope="col" className="text-center">
                        Agendamento do LED
                      </th>
                      <th scope="col" className="text-center">
                        Localização do dispositivo (piscar LED)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP310
                      </th>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP360
                      </th>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP1210AC
                      </th>
                      <td className="cross">✗</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP1250AC-MAX
                      </th>
                      <td className="cross">✗</td>
                      <td className="cross">✗</td>
                      <td className="cross">✗</td>
                      <td className="cross">✗</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP1250AC-OUTDOOR
                      </th>
                      <td className="cross">✗</td>
                      <td className="cross">✗</td>
                      <td className="cross">✗</td>
                      <td className="cross">✗</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP1350AC
                      </th>
                      <td className="cross">✗</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP1350AC-S
                      </th>
                      <td className="cross">✗</td>
                      <td className="cross">✗</td>
                      <td className="cross">✗</td>
                      <td className="cross">✗</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP1750AC
                      </th>
                      <td className="cross">✗</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP1800AX
                      </th>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP3000AX
                      </th>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                      <td className="check">✓</td>
                    </tr>
                    <tr style={{ textAlign: "center" }}>
                      <th scope="row">
                        AP3000AX-OUTDOOR
                      </th>
                      <td className="cross">✗</td>
                      <td>
                        <span className="check">✓</span> (somente alguns LEDs)
                      </td>
                      <td>
                        <span className="check">✓</span> (somente alguns LEDs)
                      </td>
                      <td className="check">✓</td>
                    </tr>
                  </tbody>
                </table>
              </div>


            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
